export const scrollToBottom = ({ scrollRef }) => {
    if (scrollRef.current) {
        setTimeout(() => {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            scrollRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 500);
    }
};

export const scrollToNewChat = ({ scrollRef }) => {
    if (scrollRef.current) {
        setTimeout(() => {
            const chatCards = scrollRef.current.querySelectorAll(".chat-card");
            if (chatCards.length > 0) {
                const lastChatCard = chatCards[chatCards.length - 1];
                // Get the position of the last chat card relative to the chat container
                const lastChatCardOffsetTop = lastChatCard.offsetTop;
                const chatContainerTop = scrollRef.current.offsetTop;
                const newScrollTop = lastChatCardOffsetTop - chatContainerTop - 10;

                // Scroll to the new position with smooth behavior
                scrollRef.current.scroll({
                    top: newScrollTop,
                    behavior: "smooth",
                });
            }
        }, 500);
    }
};